import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { auth } from '../firebase';

function VerifyEmail() {
  const { currentUser, sendVerificationEmail } = useAuth();
  const navigate = useNavigate();
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleResend = async () => {
    setMessage('');
    setError('');
    setLoading(true);
    try {
      await sendVerificationEmail();
      setMessage('確認メールを再送しました。受信トレイをご確認ください。');
    } catch (err) {
      if (err.code === 'auth/too-many-requests') {
        setError('送信回数が多すぎます。しばらく時間を置いてから再試行してください。');
      } else {
        setError('送信に失敗しました。しばらく時間を置いてから再試行してください。');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleCheck = async () => {
    setMessage('');
    setError('');
    setLoading(true);
    try {
      await auth.currentUser.reload();
      if (auth.currentUser.emailVerified) {
        navigate('/profile/edit');
      } else {
        setError('まだ確認されていません。メール内のリンクをクリックしてから再試行してください。');
      }
    } catch {
      setError('確認の取得に失敗しました。再度お試しください。');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="card auth-card">
        <h2 className="text-center mb-4">メールアドレスの確認</h2>

        <p className="text-center mb-3">
          <strong>{currentUser?.email}</strong> に確認メールを送信しました。
        </p>
        <p className="text-center text-muted mb-4" style={{ fontSize: '0.9rem' }}>
          メール内のリンクをクリックして登録を完了してください。
          確認後、下のボタンを押してください。
        </p>

        {message && <div className="alert alert-success">{message}</div>}
        {error && <div className="alert alert-danger">{error}</div>}

        <button
          className="btn btn-primary w-100"
          onClick={handleCheck}
          disabled={loading}
        >
          {loading ? '確認中...' : '確認済みにする'}
        </button>

        <div className="text-center mt-3">
          <button
            className="btn btn-link"
            onClick={handleResend}
            disabled={loading}
            style={{ fontSize: '0.85rem' }}
          >
            メールが届かない場合は再送する
          </button>
        </div>
      </div>
    </div>
  );
}

export default VerifyEmail;
